export default __webpack_public_path__ + "static/media/WEBDeepOceanSharkCartilage500x900v2.6583f324.jpg";